<template>
  <div class="w-100">
    <form ref="form" v-kendo-validator novalidate @submit.prevent="add">
      <!-- <div class="page-header d-flex w-100"> -->
      <!-- <div class="title-col d-flex w-50">
          <span class="title-icon">
            <span class="nt-person-add"></span>
          </span>
          <span class="title-text">Users</span>
      </div>-->
      <!-- <div class="text-right ml-auto">
          <button class="k-button k-primary ml-2" type="button" @click="save" v-if="!readOnly">Save</button>
      </div>-->
      <!-- </div> -->
      <div class="page-body">
        <div v-if="!readOnly">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="required-field">Name</label>
                <k-input :name="'Name'" class="w-100 rounded-border" :required="true" v-model="name" />
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label class="required-field">Email</label>
                <k-input
                  :name="'Email'"
                  type="email"
                  class="w-100 rounded-border"
                  :required="true"
                  pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$"
                  v-model="email"
                />
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label class="required-field">Phone No</label>
                <k-input
                  :name="'Phone No'"
                  type="text"
                  class="w-100 rounded-border"
                  :required="true"
                  :pattern="'^[0-9]{10}$'"
                  v-model="mobileNo"
                />
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label class="required-field">Role</label>
                <kendo-dropdownlist
                  class="w-100"
                  v-model="roles"
                  :data-source="getRoles"
                  :name="'Roles'"
                  :data-item-key="'id'"
                  :data-text-field="'roleName'"
                  :required="true"
                  :option-label="'Select'"
                  :data-value-field="'id'"
                  :value-primitive="true"
                  :item-key="'value'"
                ></kendo-dropdownlist>
              </div>
            </div>

            <div class="col-sm-2 text-right ml-auto">
              <div class="pt-4">
                <button style="border-radius: 5px;" class="k-button k-green">{{!edited?'Add':'Update'}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tenant-users-div bg-white" v-if="tenantData.length">
        <!-- <span v-if="!readOnly">Users</span> -->
        <b-table striped hover :fields="fields" :items="tenantData">
          <template v-slot:cell(action)="config">
            <!-- <button class="button is-small is-light" @click="remove(config.item)">delete</button> -->
            <span class="action-icon nt-edit" @click="edit(config.item)"></span>
            <span class="nt-trash-fill action-icon" @click="confirmDelete(config.item)"></span>
          </template>
        </b-table>
      </div>

      <!-- <div class="buttons text-right">
        <button type="button" class="save-button btn btn-primary ml-3 rounded-border"  @click="save">Save</button>
        <button type="button" style="color: #0047b2;" class="save-button btn ml-3 rounded-border" @click="activate">Save & Activate</button>
        <button type="button" style="margin-right: 10px;" class="save-button btn btn-default ml-3" @click="close">Cancel</button>
      </div> -->

    </form>
    <DialogBox
    ref="removeTenantDtl"
    :tenant="tenant"
    @OkMethod="OkMethod"
    @closed="closeDialog"
    ></DialogBox>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { createNamespacedHelpers } from "vuex";
import { notifyApiError, notify } from "../../utils/notification-helper";
import DialogBox from "@/components/DialogBox.vue";
const { mapMutations, mapActions, mapState } = createNamespacedHelpers("onboarding");
export default {
  props: ["readOnly"],
  data: function() {
    return {
      fields: [
        { key: "name", sortable: true },
        { key: "email" },
        { key: "mobileNo" },
        { key: "roleName" },
        "action"
      ],
      tenantData: [],
      edited: false,
      editedUser: {},
      tenant: {}
    };
  },
  components: {
    DialogBox,
  },
  methods: {
    ...mapMutations(["removeUser"]),
    ...mapActions(["saveUsers", "addUser","editUser","activateTenant","resetState"]),
    save: function() {
      // this.canContinue(); //TODO remove
      this.saveUsers()
        .then(message => {
          notify(message);
          this.canContinue();
        })
        .catch(notifyApiError);
    },
    close() {
      this.$router.push("tenant-management"); 
    },
    confirmDelete(e) {
      this.tenant = e;
      this.$refs.removeTenantDtl.openWindow();
    },
    OkMethod() {
      this.remove(this.tenant);
    },
    closeDialog() {
      this.$refs.removeTenantDtl.closeWindow();
    },
    add: function() {
      if (!this.kendoValidator.validate()) {
        return;
      }
      if(this.edited == false) {
      this.addUser();
      } else {
        this.editUser();
      }
      this.tenantData = this.tenantUsers.filter(item =>!(item.isDeleted == true));
      this.kendoValidator.hideMessages();
      this.mobileNo = "";
      this.email = "";
      this.name= "";
      this.id = "";
      this.roles= "";
      this.edited = false;
    },
    async getDataOnload() {
      this.mobileNo = ""
      this.email = ""
      this.name= ""
      this.id = ""
      this.roles= ""
      this.$store.dispatch("getRoles");
      this.tenantUsers.forEach(element => {
        element.roleName= this.$store.state.tenantRoles.find(item =>  item.id ==  element.roles)?.roleName         
      });
      this.tenantData = this.tenantUsers.filter(item =>!(item.isDeleted == true))
    },
    canContinue() {
      this.$emit("can-continue", { value: true });
    },
    activate() {
      this.activateTenant()
        .then(message => {
          notify(message);
          this.resetState();
          this.$store.dispatch("loadTenants", null, { root: true });
          this.$router.push("/add-tenant");
        })
        .catch(notifyApiError);
    },
    edit(userDetails) {
        this.edited = true;
        this.mobileNo = userDetails.mobileNo;
        this.email = userDetails.email;
        this.name= userDetails.name;
        this.id = userDetails.id;
        this.roles= userDetails.roles;
    },
    remove(userDetails) {
      this.removeUser(userDetails);
      this.tenantData = this.tenantUsers.filter(item =>!(item.isDeleted == true));
    }
  },
  computed: {
    ...mapFields([
      "onboarding.user.name",
      "onboarding.user.email",
      "onboarding.user.mobileNo",
      "onboarding.user.roles",
      "onboarding.user.roleName",
      "onboarding.tenantUsers"
    ]),
    ...mapState(["editField"]),
    getRoles() {
      return this.$store.state.tenantRoles;
    }
  },
  created: function() {
    this.getDataOnload();
  }
  // mounted(){
  //   this.getDataOnLoad();
  //   console.log("hello",this.$store.state.roles)
  // }
};
</script>

<style>
.tenant-users-div {
  width: 96%;
  margin: 10px auto;
}

.nt-trash-fill {
  cursor: pointer;
}

.save-button{
  width: 150px;
}
</style>